"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleNames = exports.styleNamePropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var styleNames = exports.styleNames = {
  general: 'general',
  additive: 'additive',
  subtractive: 'subtractive'
};
var styleNamePropType = exports.styleNamePropType = _propTypes["default"].oneOf([styleNames.general, styleNames.additive, styleNames.subtractive]);